import { LESS_512_MEDIA_QUERY } from '../../../../../consts/adaptive';

export const styles = {
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    inputName: {
        display: 'flex',
    },
    ratingTitle: {
        paddingRight: 3
    },
    [LESS_512_MEDIA_QUERY]: {
        inputName: {
            padding: [3, 20],
            flexDirection: 'column',
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
